import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import config from 'garaje/config/environment';
import type LocationOverviewHrisDashboardController from 'garaje/pods/location-overview/hris-dashboard/dashboard/controller';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type StateService from 'garaje/services/state';

export default class HrisDashboardDashboardRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;
  @service declare state: StateService;

  controllerName = 'location-overview/hris-dashboard/dashboard';
  templateName = 'location-overview/hris-dashboard/dashboard';

  async model(): Promise<{ snapshot: unknown; unauthorized: boolean }> {
    const companyId = this.state.currentCompany?.id;
    let snapshot = null;
    let unauthorized = false;
    try {
      snapshot = await this.ajaxFetch.request(
        `${config.hrisLifecycleApiHost}/a/hris-lifecycle/api/v1/customer-routine-snapshots?company_id=${companyId}&lifecycle_event_type=TERMINATION`,
      );
    } catch (err) {
      unauthorized = (err as { status?: number }).status === 403;
    }
    return { snapshot, unauthorized };
  }

  setupController(
    controller: LocationOverviewHrisDashboardController,
    model: { snapshot: unknown; unauthorized: boolean },
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);
    controller.loadFromSnapshot(model.snapshot, model.unauthorized);
  }
}
